import React from 'react';
import PropTypes from 'prop-types';
import { Segment, Sidebar, Menu, Icon } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';

const menuItems = [
  { name: 'Dashboard', routes: ['', 'dashboard'] },
  { name: 'Anagrafiche', routes: ['anagrafica'] },
  { name: 'Pratiche', routes: ['pratiche', 'pratica'] },
  { name: 'Co-mediazioni', routes: ['co-mediazioni-tutor'] },
  { name: 'Agenzie Kiron', routes: ['agenziakiron'] },
  { name: 'Agenzie Tecnocasa', routes: ['agenziatecnocasa'] },
  { name: 'Istituti', routes: ['istituto'] },
  { name: 'Prodotti', routes: ['prodotti'] },
  { name: 'Agenda', routes: ['agenda'] },
  { name: 'Dashboard Commissioning', routes: ['dashboard-commissioning'] },
  { name: 'Commissioning', routes: ['commissioning', 'importazione'] },
  { name: 'Blocco Provvigioni', routes: ['blocco-provvigioni'] },
  { name: 'Modulistica', routes: ['modulistica'] },
  { name: 'Area candidati', routes: ['area-candidati'] },
  { name: 'Area Neo', routes: ['area-neo'] },
  { name: 'Gestione Rete', routes: ['gestione-recessi'] },
  { name: 'Reports', routes: ['reports'] },
  { name: 'Tickets assistenza', routes: ['tickets'] },
  { name: 'Editor avvisi', routes: ['editor-avvisi'] },
  { name: 'Statistiche', routes: ['statistiche'] },
];

/**
 * Navigation Sidebar.
 */
class SidebarNav extends React.Component {
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0 };
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => this.setState({ width: window.innerWidth - 150, height: window.innerHeight - 65 });

  isActive = (match, location, name) => {
    const rootSection = location.pathname.split('/')[1];
    return menuItems.some((item) => item.name === name && item.routes.includes(rootSection));
  };

  render() {
    const { items, visible, children } = this.props;

    return (
      <Sidebar.Pushable
        as={Segment}
        basic
        style={{ position: 'fixed', inset: '51px 0 0', height: 'calc(100vh - 65px)' }}
        id="scrollable"
      >
        <Sidebar
          as={Menu}
          animation="uncover"
          width="thin"
          visible={visible}
          icon="labeled"
          style={{ backgroundColor: '#333d68!important' }}
          vertical
          inverted
        >
          {(items || []).map((item) => (
            <Menu.Item
              key={item.name}
              name={item.name.toString()}
              as={NavLink}
              to={item.route}
              isActive={(match, location) => this.isActive(match, location, item.name)}
            >
              <Icon name={item.icon} />
              {item.render || item.name}
            </Menu.Item>
          ))}
        </Sidebar>

        <Sidebar.Pusher
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: this.state.width,
            height: this.state.height,
            minHeight: this.state.height,
            overflowY: 'auto',
          }}
        >
          <Segment basic style={{ paddingBottom: 0 }}>
            {children}
          </Segment>
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    );
  }
}

SidebarNav.propTypes = {
  /** Site content */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  /** Menu links */
  items: PropTypes.array,
  /** Sidebar visibility */
  visible: PropTypes.bool,
};

export default SidebarNav;



// WEBPACK FOOTER //
// ./app/components/Nav/Sidebar/index.js